import React, {useState} from "react";
import * as ReactBootstrap from "react-bootstrap";
import {DPD} from "./DPD";
import {FBB} from "./FBB";
import {RAD} from "./RAD";

const Question = ({
                      answerType,
                      answers,
                      optional,
                      questionId,
                      questionPhrase,
                      onAnswerUpdate,
                      hierarchy,
                  }) => {
    const [expandQuestions, setExpandQuestions] = useState([])
    const [childHierarchy, setChildHierarchy] = useState([])

    const onAnswer = (value) => {
        if (answerType === 'DPD' || answerType === 'RAD') {
            const a = answers.filter((answer) => answer.answerId === value)
            if (a && a.length >= 1) {
                if (a[0].questions) {
                    setExpandQuestions([...a[0].questions])
                } else {
                    setExpandQuestions(null)
                }
                let newHierarchy = []
                if (hierarchy) {
                    newHierarchy = [
                        ...hierarchy,
                        {
                            questionId,
                            answers: [{answerId: a[0].answerId}],
                        },
                    ]
                } else {
                    newHierarchy = [
                        {
                            questionId,
                            answers: [{answerId: a[0].answerId}],
                        },
                    ]
                }

                setChildHierarchy(newHierarchy)
                if (onAnswerUpdate) {
                    onAnswerUpdate(
                        questionId,
                        a[0].answerId,
                        a[0].answerPhrase,
                        hierarchy,
                        questionPhrase,
                        answerType
                    )
                }
            }
        }
    }

    return (
        <>
            <ReactBootstrap.Col>
                <ReactBootstrap.Form.Label key={'Label' + questionPhrase}>
                    <strong>
                        <h6>
                            <span dangerouslySetInnerHTML={{__html: questionPhrase}}></span>
                            {!optional && <span className="ml-2 text-danger">*</span>}
                        </h6>
                    </strong>{' '}
                </ReactBootstrap.Form.Label>
            </ReactBootstrap.Col>
            <ReactBootstrap.Col className="pr-0 mr-0 pt-1" xs={12}>
                {answerType === 'DPD' && (
                    <DPD
                        answers={answers}
                        questionId={questionId}
                        onAnswer={(a) => onAnswer(a)}
                    />
                )}
                {answerType === 'FFB' && (
                    <FBB questionId={questionId} onAnswer={(a) => onAnswer(a)}/>
                )}
                {answerType === 'RAD' && (
                    <RAD
                        answers={answers}
                        questionId={questionId}
                        onAnswer={(a) => onAnswer(a)}
                    />
                )}

                {expandQuestions &&
                    expandQuestions.length > 0 &&
                    expandQuestions.map((q) => {
                        return (
                            <ReactBootstrap.Col className="pl-5 pr-0 mr-0 pt-1" xs={12}>
                                <Question
                                    hierarchy={childHierarchy}
                                    key={q.questionPhrase}
                                    {...q}
                                    onAnswerUpdate={onAnswerUpdate}
                                />
                            </ReactBootstrap.Col>
                        )
                    })}
            </ReactBootstrap.Col>
        </>
    )
}

export default Question
